var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGooglePlay = function SvgGooglePlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F44336"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8 237.6V15.8S18.6 9 25.8 5c6-3.4 13.3 1.4 17.2 3.4s188.4 106.8 188.4 106.8 7.3 5 7.3 13.1-6.3 11.6-10.6 14C224 144.9 36.2 251.5 36.2 251.5s-8.5 1.6-13.9-1.9c-5.5-3.6-5.5-9.7-5.5-12",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.5 115.3-44.8-25.5L26.5 251.3c4.7 1.1 9.6.2 9.6.2S224 144.9 228.2 142.4c4.3-2.5 10.6-6 10.6-14s-7.3-13.1-7.3-13.1",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.5 115.3S46.9 10.5 43.1 8.5 31.8 1.6 25.8 5.1L186 166.4l42.3-24c4.3-2.5 10.6-6 10.6-14s-7.4-13.1-7.4-13.1",
    opacity: 0.65
  }), /*#__PURE__*/React.createElement("path", {
    d: "m231.5 115.3-44.8-25.5-38.4 38.8 37.7 37.8c23.7-13.5 41-23.3 42.3-24 4.3-2.5 10.6-6 10.6-14s-7.4-13.1-7.4-13.1"
  }))));
};
export default SvgGooglePlay;